import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter, FaPrint } from 'react-icons/fa';
import Dialog from 'react-bootstrap-dialog';

import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR } from '../icon';
import BarInfoService from '../services/BarInfoService';

class PrintTailList extends Component {
  constructor() {
    super();

    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      loading: false,
      selected: {},
      spinnerVisible: false,
      fromDate: fromDate,
      toDate: toDate,
      orderNo: null,
      pcode: '',
      page: 1,
      pageSize: 10,
      pages: 0,
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true? true : false}
                  onChange={() => this.toggleRow(original)}
                /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        }, {
          Header: couterpart.translate('ORDER_NUMBER'),
          accessor: 'orderNumber',
          width: 200
        }, {
          Header: couterpart.translate('MA_P'),
          accessor: 'maP',
          filterable: false,
          width: 200,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        }, {
          Header: couterpart.translate('BARCODE'),
          accessor: 'barCode',
          width: 200,
        }, {
          Header: couterpart.translate('TEN_KH'),
          accessor: 'tenKh',
          width: 200,
        },{ 
          Header: 'SHIP_TO',
          accessor: 'shipTo',
          width: 100,
          sortable: false
        }, {
          Header: couterpart.translate('MAU'),
          accessor: 'mau',
          width: 150,
          sortable: false
        }, {
          Header: couterpart.translate('SIZE'),
          accessor: 'size',
          filterable: false,
          sortable: false,
          width: 100
        }, {
          Header: couterpart.translate('GAP'),
          accessor: 'gap',
          filterable: false,
          sortable: false,
          width: 50
        }, {
          Header: couterpart.translate('CREATED_AT'),
          accessor: 'createdAt',
          filterable: false,
          sortable: false,
          width: 200
        }, {
          Header: couterpart.translate('CREATED_BY'),
          accessor: 'createdBy',
          filterable: false,
          width: 200
        }
      ],
    };
  }

  componentDidMount() {
    let fromDate = WorkOrderUtil.getItem("superv.fromDate")
    let toDate = WorkOrderUtil.getItem("superv.toDate")

    let numOfMonths = 1; 
    if (fromDate === null || fromDate === undefined) {
      let backTime = 30 * 24 * 60 * 60 * 1000 * numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    

    this.setState({
      fromDate: fromDate,
      toDate: toDate,
    }, () => {
      this.filterOrdersBy();
    });
  }

  toggleRow(row) {
    let newSelected = Object.assign({}, this.state.selected);
    if (newSelected[row.id] === undefined) {
      newSelected[row.id] = { checked: true, id: row.id, orderNumber: row.orderNumber };
    }

    if (this.state.selected[row.id]) {
      newSelected[row.id].checked = !this.state.selected[row.id].checked;
      newSelected[row.id].id = this.state.selected[row.id].id;
      newSelected[row.id].orderNumber = this.state.selected[row.id].orderNumber;
    }

    this.setState({
      selected: newSelected,
      selectAll: 2
    }, () => {
      WorkOrderUtil.saveItem('khacprinttail.selected', JSON.stringify(this.state.selected));
    });
  }

  toggleSelectAll() {
    const newSelected = Object.assign({}, this.state.selected);
    if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: true, id: x.id, orderNumber: x.orderNumber };
        } else {
          newSelected[x.id].checked = true;
          newSelected[x.id].id = x.id;
          newSelected[x.id].orderNo = x.orderNo;
        }
      });
    } else {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: false, id: x.id, orderNumber: x.orderNumber };
        } else {
          newSelected[x.id].checked = false;
          newSelected[x.id].id = x.id;
          newSelected[x.id].orderNo = x.orderNo;
        }
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    }, () => {
      WorkOrderUtil.saveItem('khacprinttail.selected', JSON.stringify(this.state.selected));
    });
  }

  onFilter() {
    WorkOrderUtil.removeItem('khacprinttail.selected');
    this.setState({ page: 0, pageSize: 10, selected: {} },
      () => {
        this.filterOrdersBy();
      });
  }

  filterOrdersBy() {
    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0 || this.state.didMounted === false)) {
      return;
    }

    this.setState({ loading: true });
    let page = this.state.selectedPage === undefined? 0 : this.state.selectedPage;
    let pageSize = this.state.pageSize === undefined || this.state.pageSize === null? 10 :  this.state.pageSize;

    BarInfoService.fetchBarInfoEntities(page, pageSize, this.state.fromDate, this.state.toDate, this.state.orderNo, this.state.pcode)
      .then(data => {
        if (data.message === undefined && data != undefined && data.barInfoEntities !== undefined && data.barInfoEntities instanceof Array) {
          this.setState({ workOrders: data.barInfoEntities, spinnerVisible: false, loading: false, pages: data.totalPages, page: page, pageSize: pageSize});
        } else {
          this.setState({ workOrders: [], loading: false, pages: 0, page: 0, pageSize: pageSize });
          if (data.message !== undefined){
            ToastsStore.error(data.message);
          }
        }
      });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  handleFromDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate: sDate
    });
  }

  handleToDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate: sDate
    });
  }

  handleOrderNoChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      orderNo: value
    });
  }

  handlePcodeChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      pcode: value
    });
  }

  onPrintTails() {
    //console.log(this.state.selected);
    BarInfoService.printTails(Object.keys(this.state.selected))
      .then(data => {
        if (data > 0){
          ToastsStore.info("Các đơn hàng được chọn đã sẵn sàng in đuôi chuột");
        } else {
          ToastsStore.error("Các đơn hàng được chọn chưa sẵn sàng in đuôi chuột");
        }
      });
  }

  render() {
    if (!AuthenticationService.isKhac()) {
      return (<div>Unauthorized access.</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <br />
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className="col-12">
            <div className="row">
              <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-2">
                    <label><b>{couterpart.translate('order_date_from')}</b></label>:
                  </div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateFrom"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                        onChange={this.handleFromDateChange.bind(this)} /></div>
                  </div>
                  <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateTo"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                        onChange={this.handleToDateChange.bind(this)} /></div>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="row">
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.orderNo} style={{ width: "100%" }}
                      placeholder={couterpart.translate('order_no')}
                      onChange={this.handleOrderNoChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }} />
                  </div>
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.pcode} style={{ width: "100%" }}
                      placeholder={couterpart.translate('shop_pcode')}
                      onChange={this.handlePcodeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} />
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="row">
                  <div className="col-8">
                    <button className="myButton"
                      onClick={this.onFilter.bind(this)}>
                      <FaFilter color={ICON_COLOR} />
                      &nbsp;{couterpart.translate('button_filter')}
                    </button>
                  </div>
                  <div className="col-4">
                    <button className="myButton"
                      onClick={this.onPrintTails.bind(this)}>
                      <FaPrint color={ICON_COLOR} />
                      &nbsp;{couterpart.translate('reprint_tail_btn')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ReactTable
              manual
              NoDataComponent={() => null}
              previousText={"<"}
              nextText={">"}
              onPageChange={pageIndex => {
                this.setState({ selectedPage: pageIndex }, () => {
                  this.filterOrdersBy()
                })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                this.setState({ page: pageIndex, pageSize: pageSize });
              }}
              onSortedChange={sorted => {
                let sortType = this.state.sortType === 'desc' ? 'asc' : 'desc';
                this.setState({
                  sortBy: sorted[0].id,
                  sortType: sortType
                }, () => {
                  this.filterOrdersBy()
                });
              }}
              data={this.state.workOrders}
              loading={this.state.loading}
              pages={this.state.pages}
              columns={this.state.columns}
              defaultPageSize={10}
              showPageSizeOptions={true}
              pageSizeOptions={[3, 5, 10, 20]}
            />
          </div>
        </div>
        <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
        <Dialog ref={(component) => { this.dialog = component }} />
      </div>
    )
  }
}
export default withRouter(PrintTailList);